import { Instance, Objekt, Table } from '@siposdani87/sui-js';
import { app } from '../app';
import { resources } from '../resources';
import { AdminGameService } from '../services/adminGameService';
import { LanguageService } from '../services/languageService';
import { AdminController } from './adminController';

export class AdminGamesIndexController extends AdminController {
    private openSeasonId: string;
    private table: Table;

    constructor(
        instances: Instance,
        private adminGameService: AdminGameService,
        private languageService: LanguageService,
    ) {
        super(instances);

        this.openSeasonId = this.state.getParam('openSeasonId');
    }

    protected override _initToolbarButtons(): void {
        this.helper.iconButton(
            '.btn-admin-index',
            this.dom,
            () => {
                this.state.goBack('admin.index');
            },
            '',
            true,
            [],
        );

        this.helper.iconButton('.btn-games-new', this.dom, () => {
            this.adminGameService
                .newDialogByOpenSeason(this.openSeasonId)
                .then(() => {
                    this._drawContent();
                });
        });
    }

    protected override _initTable(): void {
        if (!this.table) {
            this.table = new Table(
                this.dom,
                'table',
                this.adminGameService.getTableOptions(),
            );

            this.table.setActions([
                {
                    style: () => {
                        return [
                            'edit',
                            this.languageService.translate('buttons.edit'),
                        ];
                    },
                    click: (game) => {
                        this.adminGameService
                            .editDialog(game, '/admin/')
                            .then(() => {
                                this._drawContent();
                            });
                    },
                },
            ]);

            this.table.eventAction = (params) => {
                params.set('query', this.query);
                params.set('fields', this.adminGameService.getTableFields());
                this.adminGameService
                    .getAllByOpenSeason(this.openSeasonId, params)
                    .then((response) => {
                        const count = response.get<number>('count');
                        this.table.setCount(count);
                        const games = response.get<Objekt[]>('games');
                        this.table.setData(games);
                    });
            };

            this.table.render();
        } else {
            this.table.refresh();
        }
    }
}

export const adminGamesIndexController = app.controller(
    resources.adminGamesIndexController,
    [
        resources.instances,
        resources.adminGameService,
        resources.languageService,
    ],
    AdminGamesIndexController,
);
